import * as _ from 'underscore';

import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { DatasourceContentType } from '../models/ContentTypes';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { IResult } from '../ServerApi/types/IResponse';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { IErrorDetail, INotificationTranslationIds } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';
import { ModalService } from './ModalService';

export class ChangeDatasourcesTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationIds: INotificationTranslationIds = {
    successId: 'changeTagsDatasourcesSuccess',
    errorId: 'changeTagsDatasourcesError'
  };

  public execute: (itemSet: Set<IDataSourceBase>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService','$translate', 'DataSources', 'ModalService'];

  constructor(
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
    private DataSources: DataSources,
    private ModalService: ModalService
  ) {
    this.execute = ChangeTagsActionHelper.createExecuteFn<IDataSourceBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => this.DataSources.changeTags(ids, addTags, removeTags),
      getDescription: (datasources: Set<IDataSourceBase>) => this.getDescription(datasources),
      notificationIds: ChangeDatasourcesTagsAction.notificationTranslationIds,
      errorDetailFn: (errorItem: IErrorItem<IDataSourceBase>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(datasources: Set<IDataSourceBase>) {
    return (datasources.size() === 1)
      ? this.$translate.instant('changeTagsDatasourceDescription', { NAME: L10n.elideIfLong(datasources.first().name) })
      : this.$translate.instant('changeTagsDatasourcesDescription', { COUNT: datasources.size() }, L10n.Interpolations.Count);
  }

  public showChangeTagsDialog(datasources: Set<IDataSourceBase>,
                              actionContext: IActionContext): ng.IPromise<IResult> {

    // Disallow changing tags if all selected datasources are embedded.
    if (datasources.all((ds: IDataSourceBase) => _.isObject(ds.workbook))) {
      return this.ModalService.alert({
        titleId: 'changeTagsDatasource_cannotTagAlertTitle',
        messageId: 'changeTagsDatasource_cannotTagAlertMessage'
      }).result;
    }

    return this.execute(datasources, actionContext);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<IDataSourceBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, DatasourceContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeDatasourcesTagsAction', ChangeDatasourcesTagsAction);
